import React, { useState } from 'react';
import ImageRectangleHorizontal from '../images/gallery/rektangel_liggande.jpg';
import ImageSquare from '../images/gallery/kvadrat.jpg';
import ImageRectangleVertical from '../images/gallery/rektangel_staende.jpg';

const shapes = [
  { name: 'Liggande', id: '3:2', image: ImageRectangleHorizontal },
  { name: 'Stående', id: '2:3', image: ImageRectangleVertical },
  { name: 'Kvadrat', id: '2:2', image: ImageSquare },
];

const ShapeFilter = (props) => {
  const [selectedShape, setSelectedShape] = useState('');

  const handleShapeClick = (shapeId) => {
    const next = shapeId === selectedShape ? '' : shapeId;
    setSelectedShape(next);
    props.setSelectedShape(next);
  };

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px' }}>
        {shapes.map((shape) => {
          const active = props.selectedShape === shape.id;
          return (
            <button
              key={shape.id}
              onClick={() => handleShapeClick(shape.id)}
              style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px',
                padding: '14px 8px', borderRadius: '12px', cursor: 'pointer',
                border: active ? '2px solid #161825' : '2px solid #eee',
                backgroundColor: active ? '#f8f7ff' : '#fff',
                transition: 'all 0.15s ease',
              }}
              onMouseOver={(e) => { if (!active) e.currentTarget.style.borderColor = '#ccc'; }}
              onMouseOut={(e) => { if (!active) e.currentTarget.style.borderColor = active ? '#161825' : '#eee'; }}
            >
              <img
                src={shape.image}
                alt={shape.name}
                style={{
                  width: 56, height: 56, objectFit: 'cover', borderRadius: '8px',
                  border: active ? '2px solid #161825' : '2px solid #e5e5e5',
                  transition: 'border-color 0.15s ease',
                }}
              />
              <span style={{
                fontSize: '13px', fontWeight: active ? 600 : 400,
                color: active ? '#161825' : '#555',
              }}>
                {shape.name}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ShapeFilter;
